import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-20474b38"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Continuar", -1))
const _hoisted_2 = [
  _hoisted_1
]
const _hoisted_3 = { class: "ant-row" }
const _hoisted_4 = { class: "ant-col ant-col-xl-12 ant-col-xs-12 ss-div-origem" }
const _hoisted_5 = ["disabled"]
const _hoisted_6 = { class: "ant-row ss-div-icone" }
const _hoisted_7 = { class: "ant-col ant-col-xl-24 ant-col-xs-24" }
const _hoisted_8 = ["src"]
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ant-row ss-div-titulo" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xl-24 ant-col-xs-24" }, [
    /*#__PURE__*/_createElementVNode("span", null, "Notas contra CNPJ")
  ])
], -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ant-row ss-div-dica contra-cnpj" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xl-24 ant-col-xs-24" }, [
    /*#__PURE__*/_createElementVNode("span", null, "Analise notas contra o meu CNPJ para agilizar o processo.")
  ])
], -1))
const _hoisted_11 = { class: "ant-col ant-col-xl-12 ant-col-xs-12 ss-div-origem" }
const _hoisted_12 = { class: "ant-row ss-div-icone" }
const _hoisted_13 = { class: "ant-col ant-col-xl-24 ant-col-xs-24" }
const _hoisted_14 = ["src"]
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ant-row ss-div-titulo" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xl-24 ant-col-xs-24" }, [
    /*#__PURE__*/_createElementVNode("span", null, "Chave de Acesso")
  ])
], -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ant-row ss-div-dica chave-acesso" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xl-24 ant-col-xs-24" }, [
    /*#__PURE__*/_createElementVNode("span", null, "Digite uma chave de acesso para obter as informações direto da SEFAZ.")
  ])
], -1))
const _hoisted_17 = { class: "ant-row" }
const _hoisted_18 = { class: "ant-col ant-col-xl-12 ant-col-xs-12 ss-div-origem" }
const _hoisted_19 = { class: "ant-row ss-div-icone" }
const _hoisted_20 = { class: "ant-col ant-col-xl-24 ant-col-xs-24" }
const _hoisted_21 = ["src"]
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ant-row ss-div-titulo" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xl-24 ant-col-xs-24" }, [
    /*#__PURE__*/_createElementVNode("span", null, "Importar XML")
  ])
], -1))
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ant-row ss-div-dica importacao" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xl-24 ant-col-xs-24" }, [
    /*#__PURE__*/_createElementVNode("span", null, "Selecione um arquivo XML de uma NF-e e preencher o dados automaticamente.")
  ])
], -1))
const _hoisted_24 = { class: "ant-btn ss-button manual" }
const _hoisted_25 = { class: "ant-row ss-div-icone" }
const _hoisted_26 = { class: "ant-col ant-col-xl-24 ant-col-xs-24" }
const _hoisted_27 = ["src"]
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ant-row ss-div-titulo" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xl-24 ant-col-xs-24" }, [
    /*#__PURE__*/_createElementVNode("span", null, "Manual")
  ])
], -1))
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ant-row ss-div-dica manual" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xl-24 ant-col-xs-24" }, [
    /*#__PURE__*/_createElementVNode("span", null, "Digite todas as informações do recebimento de forma manual.")
  ])
], -1))
const _hoisted_30 = { class: "ant-row" }
const _hoisted_31 = { class: "ant-col ant-col-xl-12 ant-col-xs-12 ss-div-origem" }
const _hoisted_32 = { class: "ant-row ss-div-icone" }
const _hoisted_33 = { class: "ant-col ant-col-xl-24 ant-col-xs-24" }
const _hoisted_34 = ["src"]
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ant-row ss-div-titulo" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xl-24 ant-col-xs-24" }, [
    /*#__PURE__*/_createElementVNode("span", null, "Pedido de Compra")
  ])
], -1))
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ant-row ss-div-dica contra-cnpj" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xl-24 ant-col-xs-24" }, [
    /*#__PURE__*/_createElementVNode("span", null, "Selecione um pedido de compra para agilizar o processo.")
  ])
], -1))
const _hoisted_37 = { class: "ant-btn ss-button manual" }
const _hoisted_38 = { class: "ant-row ss-div-icone" }
const _hoisted_39 = { class: "ant-col ant-col-xl-24 ant-col-xs-24" }
const _hoisted_40 = ["src"]
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ant-row ss-div-titulo" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xl-24 ant-col-xs-24" }, [
    /*#__PURE__*/_createElementVNode("span", null, "CT-e Manual")
  ])
], -1))
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ant-row ss-div-dica manual" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xl-24 ant-col-xs-24" }, [
    /*#__PURE__*/_createElementVNode("span", null, "Digite todas as informações do conhecimento de transporte de forma manual.")
  ])
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_icone = _resolveComponent("icone")!
  const _component_a_alert = _resolveComponent("a-alert")!
  const _component_card = _resolveComponent("card")!
  const _component_recebimento_mercadorias_importar_xml = _resolveComponent("recebimento-mercadorias-importar-xml")!
  const _component_recebimento_mercadorias_nota_contra_cnpj = _resolveComponent("recebimento-mercadorias-nota-contra-cnpj")!
  const _component_recebimento_mercadorias_importar_chave_acesso = _resolveComponent("recebimento-mercadorias-importar-chave-acesso")!
  const _component_recebimento_mercadorias_revisar_informacoes = _resolveComponent("recebimento-mercadorias-revisar-informacoes")!
  const _component_recebimento_mercadorias_pedido_compra = _resolveComponent("recebimento-mercadorias-pedido-compra")!
  const _component_a_spin = _resolveComponent("a-spin")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createBlock(_component_a_modal, {
    title: _ctx.state.tituloModal,
    keyboard: false,
    visible: _ctx.modalBase.computedVisivel,
    "onUpdate:visible": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.modalBase.computedVisivel) = $event)),
    width: _ctx.state.widthModal,
    centered: "",
    "wrap-class-name": _ctx.state.classModal
  }, {
    closeIcon: _withCtx(() => [
      _createVNode(_component_icone, { nome: "voltar" })
    ]),
    footer: _withCtx(() => [
      ((_ctx.state.apresentarRevisaoInformacoes && _ctx.state.apresentarAcoes))
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            type: "button",
            class: "ant-btn ant-btn-lg ant-btn-primary ss-btn-acao-destaque",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.continuarImportacaoRecebimento()))
          }, _hoisted_2))
        : _createCommentVNode("", true)
    ]),
    default: _withCtx(() => [
      (_ctx.state.retornoVerificacao.status !== _ctx.EStatusRetornoRequisicao.Sucesso)
        ? (_openBlock(), _createBlock(_component_a_alert, {
            key: 0,
            message: "Verifique seu certificado ou entre em contato com nosso suporte.",
            type: "warning",
            "show-icon": ""
          }))
        : _createCommentVNode("", true),
      ((_ctx.state.apresentarSelecaoOrigem))
        ? (_openBlock(), _createBlock(_component_card, {
            key: 1,
            titulo: "Escolha uma opção para iniciar o recebimento"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("button", {
                    class: "ant-btn ss-button contra-cnpj",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.escolherOrigem(_ctx.EOrigemRecebimentoMercadoria.NotasContraCnpj))),
                    disabled: _ctx.state.retornoVerificacao.status !== _ctx.EStatusRetornoRequisicao.Sucesso
                  }, [
                    _createElementVNode("div", _hoisted_6, [
                      _createElementVNode("div", _hoisted_7, [
                        _createElementVNode("img", {
                          class: "ss-icone",
                          src: '/static/img/compras/recebimento-mercadorias/notas-contra-cnpj.png'
                        }, null, 8, _hoisted_8)
                      ])
                    ]),
                    _hoisted_9,
                    _hoisted_10
                  ], 8, _hoisted_5)
                ]),
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("button", {
                    class: "ant-btn ss-button chave-acesso",
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.escolherOrigem(_ctx.EOrigemRecebimentoMercadoria.ConsultaChave)))
                  }, [
                    _createElementVNode("div", _hoisted_12, [
                      _createElementVNode("div", _hoisted_13, [
                        _createElementVNode("img", {
                          class: "ss-icone",
                          src: '/static/img/compras/recebimento-mercadorias/recebimento-chave-acesso.png'
                        }, null, 8, _hoisted_14)
                      ])
                    ]),
                    _hoisted_15,
                    _hoisted_16
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_17, [
                _createElementVNode("div", _hoisted_18, [
                  _createElementVNode("button", {
                    class: "ant-btn ss-button importacao",
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.escolherOrigem(_ctx.EOrigemRecebimentoMercadoria.ImportacaoXML)))
                  }, [
                    _createElementVNode("div", _hoisted_19, [
                      _createElementVNode("div", _hoisted_20, [
                        _createElementVNode("img", {
                          class: "ss-icone",
                          src: '/static/img/compras/recebimento-mercadorias/importacao-xml.png'
                        }, null, 8, _hoisted_21)
                      ])
                    ]),
                    _hoisted_22,
                    _hoisted_23
                  ])
                ]),
                _createElementVNode("div", {
                  class: "ant-col ant-col-xl-12 ant-col-xs-12 ss-div-origem",
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.escolherOrigem(_ctx.EOrigemRecebimentoMercadoria.Manual)))
                }, [
                  _createElementVNode("button", _hoisted_24, [
                    _createElementVNode("div", _hoisted_25, [
                      _createElementVNode("div", _hoisted_26, [
                        _createElementVNode("img", {
                          class: "ss-icone",
                          src: '/static/img/compras/recebimento-mercadorias/recebimento-manual.png'
                        }, null, 8, _hoisted_27)
                      ])
                    ]),
                    _hoisted_28,
                    _hoisted_29
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_30, [
                _createElementVNode("div", _hoisted_31, [
                  _createElementVNode("button", {
                    class: "ant-btn ss-button manual",
                    onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.escolherOrigem(_ctx.EOrigemRecebimentoMercadoria.PedidoCompra)))
                  }, [
                    _createElementVNode("div", _hoisted_32, [
                      _createElementVNode("div", _hoisted_33, [
                        _createElementVNode("img", {
                          class: "ss-icone",
                          src: '/static/img/compras/recebimento-mercadorias/recebimento-manual.png'
                        }, null, 8, _hoisted_34)
                      ])
                    ]),
                    _hoisted_35,
                    _hoisted_36
                  ])
                ]),
                _createElementVNode("div", {
                  class: "ant-col ant-col-xl-12 ant-col-xs-12 ss-div-origem",
                  onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.escolherOrigem(_ctx.EOrigemRecebimentoMercadoria.CTeManual)))
                }, [
                  _createElementVNode("button", _hoisted_37, [
                    _createElementVNode("div", _hoisted_38, [
                      _createElementVNode("div", _hoisted_39, [
                        _createElementVNode("img", {
                          class: "ss-icone",
                          src: '/static/img/compras/recebimento-mercadorias/recebimento-manual.png'
                        }, null, 8, _hoisted_40)
                      ])
                    ]),
                    _hoisted_41,
                    _hoisted_42
                  ])
                ])
              ])
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      _createVNode(_component_a_spin, {
        spinning: (_ctx.state.importandoRecebimento)
      }, {
        default: _withCtx(() => [
          (_ctx.state.apresentarImportacaoXml)
            ? (_openBlock(), _createBlock(_component_recebimento_mercadorias_importar_xml, {
                key: 0,
                empresa: _ctx.props.empresa,
                onImportarNfe: _ctx.criarRecebimentoPorNotaFiscal
              }, null, 8, ["empresa", "onImportarNfe"]))
            : _createCommentVNode("", true),
          (_ctx.state.apresentarNotasContraCnpj)
            ? (_openBlock(), _createBlock(_component_recebimento_mercadorias_nota_contra_cnpj, {
                key: 1,
                empresa: _ctx.props.empresa,
                onImportarNfe: _ctx.criarRecebimentoPorNotaFiscal
              }, null, 8, ["empresa", "onImportarNfe"]))
            : _createCommentVNode("", true),
          (_ctx.state.apresentarImportacaoChaveAcesso)
            ? (_openBlock(), _createBlock(_component_recebimento_mercadorias_importar_chave_acesso, {
                key: 2,
                empresa: _ctx.props.empresa,
                onImportarNfe: _ctx.criarRecebimentoPorNotaFiscal
              }, null, 8, ["empresa", "onImportarNfe"]))
            : _createCommentVNode("", true),
          (_ctx.state.apresentarRevisaoInformacoes)
            ? (_openBlock(), _createBlock(_component_recebimento_mercadorias_revisar_informacoes, {
                key: 3,
                empresa: _ctx.props.empresa,
                recebimentoMercadoria: _ctx.state.recebimentoMercadoria,
                "onUpdate:recebimentoMercadoria": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.state.recebimentoMercadoria) = $event)),
                apresentarAcoes: _ctx.state.apresentarAcoes,
                "onUpdate:apresentarAcoes": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.state.apresentarAcoes) = $event))
              }, null, 8, ["empresa", "recebimentoMercadoria", "apresentarAcoes"]))
            : _createCommentVNode("", true),
          (_ctx.state.apresentarImportacaoPedidoCompra)
            ? (_openBlock(), _createBlock(_component_recebimento_mercadorias_pedido_compra, {
                key: 4,
                empresa: _ctx.props.empresa,
                onImportarNfe: _ctx.criarRecebimentoPorPedido
              }, null, 8, ["empresa", "onImportarNfe"]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["spinning"])
    ]),
    _: 1
  }, 8, ["title", "visible", "width", "wrap-class-name"]))
}